import {
    Component,
    Input,
    TemplateRef,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    KpiResultDataEntryResponsePeriod,
    KpiResultPeriod,
} from '@masar/common/models';
import { KpiMeasurementCycleType } from '@masar/common/types';

@Component({
    selector: 'app-period-tab-list',
    templateUrl: './period-tab-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PeriodTabListComponent {
    @Input() public periods: (
        KpiResultPeriod | KpiResultDataEntryResponsePeriod
    )[];
    @Input() public measurementCycle: KpiMeasurementCycleType;
    @Input() public contentTemplate: TemplateRef<any>;
}
